import { useMemo } from 'react'
import { AccountHomeTaskMapKey } from '../AccountHomeLink/AccountHomeLink'

const defaults: { [key: string]: AccountHomeTaskMapKey[] } = {
  providers: [
    'checkProviders',
    'findProviders',
    'checkPreventiveServices',
    'updatePharmacies',
    'updateDrugs'
  ],
  claims: ['checkClaims', 'getEmsns', 'checkDeductible'],
  plans: ['planDetails', 'findPlans'],
  premiums: ['checkPremiums', 'payPremium'],
  settings: [
    'editAccountSettings',
    'manageReps',
    'getMedicareCard',
    'download',
    'connectedApps'
  ]
}
type usePersonalizedAllOptionsArgs = {
  eMsnEnrolled: boolean
}
export function usePersonalizedAllOptions ({
  eMsnEnrolled
}: usePersonalizedAllOptionsArgs): typeof defaults {
  return useMemo(() => {
    const claims: AccountHomeTaskMapKey[] = eMsnEnrolled
      ? defaults.claims
      : ['checkClaims', 'getEmsns2', 'checkDeductible']
    return {
      ...defaults,
      claims
    }
  }, [eMsnEnrolled])
}
